<button mat-menu-item [disabled]="disabled">
    <ng-content />
</button>
